__turbopack_context__.v({
  "wrapper": "ContentWrapper-module__JGWoJa__wrapper",
});
